import { graphql } from "@opensea/graphql"

export const seaportOrderFragment = graphql(`
  fragment seaportOrder on SeaportOrderComponents {
    offerer
    zone
    offer {
      itemType
      token
      identifierOrCriteria
      startAmount
      endAmount
    }
    consideration {
      itemType
      token
      identifierOrCriteria
      startAmount
      endAmount
      recipient
    }
    orderType
    startTime
    endTime
    zoneHash
    salt
    conduitKey
    counter
  }
`)
